import { render, staticRenderFns } from "./redirections-list.view.vue?vue&type=template&id=3e3ec02e"
import script from "./redirections-list.view.vue?vue&type=script&lang=ts"
export * from "./redirections-list.view.vue?vue&type=script&lang=ts"
import style0 from "./redirections-list.view.vue?vue&type=style&index=0&id=3e3ec02e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports